import { getMinimalDecisionInfo } from "api";
import { Error } from "utils/Response";
import { ActionTypes } from "./types";

export const GetMinimalDecisionInfo = () => async (dispatch) => {
  try {
    dispatch({ type: ActionTypes.LOADING });
    const { data, status } = await getMinimalDecisionInfo();
    dispatch({
      type: ActionTypes.SUCCESS,
      payload: data,
    });
    if (status === 200) {
    }
  } catch (error) {
    Error(error?.response?.data?.error);
    dispatch({
      type: ActionTypes.ERROR,
      payload: error,
    });
  }
};

export const SetMinimalDecisionInfo = (data) => (dispatch) => {
  dispatch({
    type: ActionTypes.SET_MINIMAL_DECISION,
    payload: data,
  });
};

export const DeleteMinimalDecisionInfoReducer = (id) => async (dispatch) => {
  dispatch({
    type: ActionTypes.DELETE_MINIMAL_DECISION,
    payload: id,
  });
};